import { render } from "./ResolvingLimitationModal.vue?vue&type=template&id=3a5056af&ts=true"
import script from "./ResolvingLimitationModal.vue?vue&type=script&lang=ts"
export * from "./ResolvingLimitationModal.vue?vue&type=script&lang=ts"

import "./ResolvingLimitationModal.vue?vue&type=style&index=0&id=3a5056af&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__